<template>
    <div :class="computedColClass">
        <div :class="wrapperClass">

            <div v-for="option in options" :key="option.value" :class="optionWrapperClass">
                <!-- RADIO INPUT -->
                <input
                    type="radio"
                    :id="`${inputId}-${option.value}`"
                    :name="fieldName"
                    :value="option.value"
                    :checked="modelValue === option.value"
                    @change="$emit('update:modelValue', option.value)"
                    :disabled="disabled"
                    :class="computedInputClass"
                />

                <!-- LABEL -->
                <label :for="`${inputId}-${option.value}`" :class="labelClass">
                    {{ option.label }}
                </label>
            </div>

            <!-- ERROR MESSAGE -->
            <Error
                v-if="hasError"
                :id="errorId"
                :message="errorMessage"
                :bootstrap="bootstrap"
            />

        </div>
    </div>
</template>

<script setup>
import { computed } from "vue";
import { useValidationStore } from '../../stores/validationStore.js';

const props = defineProps({
    modelValue: [String, Number],
    options: { type: Array, required: true },
    field: { type: String, required: true },
    inputId: String,
    col: String,
    disabled: Boolean,
    bootstrap: { type: Boolean, default: false },
    req: { type: Boolean, default: false }
});

const validationStore = useValidationStore();

// Computed field name
const fieldName = computed(() => {
    const shortKey = props.field.split(".").pop();
    return validationStore.hasError(props.field) ? props.field
        : validationStore.hasError(shortKey) ? shortKey
            : props.field;
});

// Computed IDs
const inputId = computed(() => props.inputId ?? fieldName.value);
const errorId = computed(() => `error-${inputId.value}`);

// Validation
const errorMessage = computed(() => validationStore.getErrors(fieldName.value));
const hasError = computed(() => validationStore.hasError(fieldName.value));

// Col class
const computedColClass = computed(() => {
    if (props.col) return props.col;
    return props.bootstrap
        ? 'col-12 col-md-6 col-lg-4'
        : 'col-span-12 md:col-span-6 lg:col-span-4';
});

// Wrapper class
const wrapperClass = computed(() => props.bootstrap ? 'd-flex align-items-center mb-3 flex-wrap' : 'flex flex-wrap items-center mb-3 gap-4');

// Each option wrapper class
const optionWrapperClass = computed(() => props.bootstrap ? 'form-check me-3' : 'flex items-center space-x-2');

// Input class
const computedInputClass = computed(() => {
    if (props.bootstrap) {
        return [
            'form-check-input',
            hasError.value ? 'is-invalid' : ''
        ].join(' ');
    } else {
        return [
            'rounded border-gray-300 text-green-600 focus:ring-green-500 focus:ring-2',
            hasError.value ? 'border-red-500' : ''
        ].join(' ');
    }
});

// Label class
const labelClass = computed(() => props.bootstrap ? 'form-check-label' : 'text-gray-700 font-medium');

</script>
